<template>
    <v-dialog v-model="dialog"
              @click:outside="closeDialog"
              scrollable
              max-width="700px"
    >
        <v-card>
            <address-finder @address-confirmed="fillAddress" ref="addressFinderDialog"></address-finder>
            <v-toolbar dense :elevation="0">
                <v-toolbar-title class="text-primary-700">
                    New Scheme Property
                </v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-btn style="width: 35px; height: 35px" icon @click="closeDialog">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pt-4" style="max-height:650px; overflow-y: scroll;">
                <form>
                  <template id="section-scheme">
                    <h5 class="text-h7 mb-1 pa-0">Scheme</h5>
                    <v-combobox
                      outlined
                      dense
                      hide-details
                      :disabled="prefill"
                      v-model="form.scheme"
                      :items="scheme.items"
                      :search-input.sync="scheme.search"
                      :item-text="'label'"
                      return-object
                      placeholder="Begin typing to search for a scheme"
                      label="Scheme"
                      :loading="scheme.loading"
                      clearable
                      :filter="(item, queryText) => {
                        return item
                      }"
                      ref="schemeCombobox"
                    ></v-combobox>
                  </template>

                  <v-divider class="my-8"></v-divider>

                  <template id="section-address">
                    <div style="display: flex; z-index: 20;">
                      <h5 class="text-h7 mb-1 pa-0">Address</h5>
                      <v-spacer></v-spacer>
                      <h5 class="text-h7 mb-1 pa-0">Filled from Scheme</h5>
                    </div>
                    
                    <v-row>
                        <v-col cols="6">
                          <v-text-field
                            outlined
                            dense
                            hide-details
                            v-model="form.address.street"
                            v-validate="''"
                            :error-messages="errors.collect('form.address.street')"
                            label="Street"
                            data-vv-name="form.address.street"
                            data-vv-as="Street"
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            outlined
                            dense
                            hide-details
                            v-model="form.address.street2"
                            v-validate="''"
                            :error-messages="errors.collect('form.address.street2')"
                            label="Street 2 (Optional)"
                            data-vv-name="form.address.street2"
                            data-vv-as="Street 2"
                            disabled
                          ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          v-model="form.address.city"
                          v-validate="''"
                          :error-messages="errors.collect('form.address.city')"
                          label="City"
                          data-vv-name="form.address.city"
                          data-vv-as="City"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          v-model="form.address.region"
                          v-validate="''"
                          :error-messages="errors.collect('form.address.region')"
                          label="Region"
                          data-vv-name="form.address.region"
                          data-vv-as="Region"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          v-model="form.address.post_code"
                          v-validate="''"
                          :error-messages="errors.collect('form.address.post_code')"
                          label="Post Code"
                          data-vv-name="form.address.post_code"
                          data-vv-as="Post Code"
                          disabled
                        ></v-text-field>
                      </v-col>

                    </v-row>
                    <v-row>
                      <v-col cols="8">
                        <v-autocomplete
                          outlined
                          dense
                          hide-details
                          v-model="form.address.country"
                          :items="countries"
                          cache-items
                          flat
                          hide-no-data
                          item-text="name"
                          item-value="name"
                          label="Country"
                          v-validate="''"
                          :error-messages="errors.collect('form.address.country')"
                          data-vv-name="form.address.country"
                          data-vv-as="Country"
                          disabled
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="4">
                          <v-text-field
                              outlined
                              dense
                              hide-details
                              v-model="form.building_num"
                              v-validate="''"
                              :error-messages="errors.collect('form.building_num')"
                              label="Unit"
                              data-vv-name="form.building_num"
                              data-vv-as="Unit"
                          ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>

                  <v-divider class="my-8"></v-divider>

                  <template id="section-property-info">
                    <h5 class="text-h7 mb-1 pa-0">Property Info</h5>

                    <v-row>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                dense
                                hide-details
                                v-model="form.company_id"
                                :loading="tenants.loading"
                                :items="tenants.items"
                                :search-input.sync="tenants.search"
                                cache-items
                                flat
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Tenant"
                                v-validate="''"
                                :error-messages="errors.collect('form.company_id')"
                                data-vv-name="form.company_id"
                                data-vv-as="Tenant"
                            >
                            <template v-slot:append>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon @click="createCompany('tenant')"v-on="on">mdi-plus</v-icon>
                                </template>
                                <span>Create a new tenant</span>
                              </v-tooltip>
                            </template> 
                            <template v-slot:item="{ item }">
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ item.name }}
                                  <v-tooltip bottom v-if="item.core_id">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                      small
                                        :color="verifyRetailer(item).icon"
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        mdi-checkbox-marked-circle-outline
                                      </v-icon>
                                    </template>
                                    <span>{{verifyRetailer(item).tooltip}}</span>
                                  </v-tooltip>
                                </v-list-item-title>
                              </v-list-item-content>
                            </template></v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                dense
                                hide-details
                                v-model="form.legal_tenant_id"
                                :loading="legalTenants.loading"
                                :items="legalTenants.items"
                                :search-input.sync="legalTenants.search"
                                cache-items
                                flat
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Tenant (Legal)"
                                v-validate="''"
                                :error-messages="errors.collect('form.legal_tenant_id')"
                                data-vv-name="form.legal_tenant_id"
                                data-vv-as="Tenant (Legal)"
                                hint="Optionally set the company which is the legal tenant, if it is different."
                                persistent-hint
                            >
                            <template v-slot:append>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon @click="createCompany('legal_tenant')"v-on="on">mdi-plus</v-icon>
                                </template>
                                <span>Create a new tenant</span>
                              </v-tooltip>
                            </template>
                            <template v-slot:item="{ item }">
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ item.name }}
                                  <v-tooltip bottom v-if="item.core_id">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                      small
                                        :color="verifyRetailer(item).icon"
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        mdi-checkbox-marked-circle-outline
                                      </v-icon>
                                    </template>
                                    <span>{{verifyRetailer(item).tooltip}}</span>
                                  </v-tooltip>
                                </v-list-item-title>
                              </v-list-item-content>
                            </template></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                small-chips
                                deletable-chips
                                multiple
                                hide-details
                                v-model="form.tenant_agents"
                                :loading="tenantAgents.loading"
                                :items="tenantAgents.items"
                                :search-input.sync="tenantAgents.search"
                                cache-items
                                flat
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Tenant Agents"
                                v-validate="''"
                                :error-messages="errors.collect('form.tenant_agents')"
                                data-vv-name="form.tenant_agents"
                                data-vv-as="Tenant Agent"
                            >
                            <template v-slot:append>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon @click="createCompany('tenant_agent')"v-on="on">mdi-plus</v-icon>
                                </template>
                                <span>Create a new tenant agent</span>
                              </v-tooltip>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                small-chips
                                deletable-chips
                                multiple
                                hide-details
                                v-model="form.tenant_agent_contacts"
                                :loading="tenantAgentContacts.loading"
                                :items="tenantAgentContacts.items"
                                :search-input.sync="tenantAgentContacts.search"
                                cache-items
                                flat
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Tenant Agent Contacts"
                                v-validate="''"
                                :error-messages="errors.collect('form.tenant_agent_contacts')"
                                data-vv-name="form.tenant_agent_contacts"
                                data-vv-as="Tenant Agent Contact"
                            >
                            <template v-slot:append>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon @click="createUser('tenant_agent_contact')"v-on="on">mdi-plus</v-icon>
                                </template>
                                <span>Create a new tenant agent contact</span>
                              </v-tooltip>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                small-chips
                                deletable-chips
                                multiple
                                hide-details
                                v-model="form.tenant_contacts"
                                :loading="tenantContacts.loading"
                                :items="tenantContacts.items"
                                :search-input.sync="tenantContacts.search"
                                cache-items
                                flat
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Tenant Contacts"
                                v-validate="''"
                                :error-messages="errors.collect('form.tenant_contacts')"
                                data-vv-name="form.tenant_contacts"
                                data-vv-as="Tenant Contact"
                            >
                            <template v-slot:append>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon @click="createUser('tenant_contact')"v-on="on">mdi-plus</v-icon>
                                </template>
                                <span>Create a new tenant contact</span>
                              </v-tooltip>
                            </template>
                          </v-autocomplete>
                        </v-col>
                    </v-row>
                  </template>

                  <v-divider class="my-8"></v-divider>

                  <template id="section-areas">
                    <h5 class="text-h7 mb-1 pa-0">Areas</h5>
                    <v-row>
                        
                        <v-col cols="4" v-if="areaChecklist.nia_sqrt || areaChecklist.mezzanine || areaChecklist.garden_centre || areaChecklist.itza_area || areaChecklist.ground_floor_area || areaChecklist.first_floor_area || areaChecklist.second_floor_area || areaChecklist.third_floor_area || areaChecklist.basement_area || areaChecklist.frontage_area">
                            <!-- dont show area type if there arent any fields that use it -->
                            <v-autocomplete
                            outlined
                            dense
                            hide-details
                            v-model="form.area_size_type"
                            :items="[{value:'sqft', name:'sqft'}, {value:'sqm', name:'sqm'}]"
                            cache-items
                            flat
                            hide-no-data
                            clearable
                            item-text="name"
                            item-value="value"
                            label="Area"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.nia_sqrt">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.nia_sqrt"
                                v-validate="''"
                                :error-messages="errors.collect('form.nia_sqrt')"
                                label="NIA"
                                data-vv-name="form.nia_sqrt"
                                data-vv-as="NIA"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.mezzanine">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.mezzanine"
                                v-validate="''"
                                :error-messages="errors.collect('form.mezzanine')"
                                label="Mezz/FF"
                                data-vv-name="form.mezzanine"
                                data-vv-as="Mezz/FF"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.garden_centre">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.garden_centre"
                                v-validate="''"
                                :error-messages="errors.collect('form.garden_centre')"
                                label="GC"
                                data-vv-name="form.garden_centre"
                                data-vv-as="GC"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.itza_area">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.itza_area"
                                v-validate="''"
                                :error-messages="errors.collect('form.itza_area')"
                                label="ITZA"
                                data-vv-name="form.itza_area"
                                data-vv-as="ITZA"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.ground_floor_area">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.ground_floor_area"
                                v-validate="''"
                                :error-messages="errors.collect('form.ground_floor_area')"
                                label="Ground Floor"
                                data-vv-name="form.ground_floor_area"
                                data-vv-as="Ground Floor"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.first_floor_area">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.first_floor_area"
                                v-validate="''"
                                :error-messages="errors.collect('form.first_floor_area')"
                                label="First Floor"
                                data-vv-name="form.first_floor_area"
                                data-vv-as="First Floor"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.second_floor_area">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.second_floor_area"
                                v-validate="''"
                                :error-messages="errors.collect('form.second_floor_area')"
                                label="Second Floor"
                                data-vv-name="form.second_floor_area"
                                data-vv-as="Second Floor"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.third_floor_area">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.third_floor_area"
                                v-validate="''"
                                :error-messages="errors.collect('form.third_floor_area')"
                                label="Third Floor"
                                data-vv-name="form.third_floor_area"
                                data-vv-as="Third Floor"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.basement_area">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.basement_area"
                                v-validate="''"
                                :error-messages="errors.collect('form.basement_area')"
                                label="Basement"
                                data-vv-name="form.basement_area"
                                data-vv-as="Basement"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.frontage_area">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.frontage_area"
                                v-validate="''"
                                :error-messages="errors.collect('form.frontage_area')"
                                label="Frontage"
                                data-vv-name="form.frontage_area"
                                data-vv-as="Frontage"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-menu offset-y :close-on-content-click="false">
                            <template v-slot:activator="{ on: onMenu }">
                              <v-btn @click="" height="40" width="100%" color="primary" outlined v-on="onMenu">
                                <v-icon>mdi-plus</v-icon>
                                Add Areas
                              </v-btn>
                            </template>
                            <!-- checkbox for each area type -->
                            <v-card style="width: 400px;" class="px-4 py-4">
                              <v-row>
                                <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.nia_sqrt" label="NIA"></v-checkbox>
                                  </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.mezzanine" label="Mezz/FF"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.garden_centre" label="GC"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.itza_area" label="ITZA"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.ground_floor_area" label="Ground Floor"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.first_floor_area" label="First Floor"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.second_floor_area" label="Second Floor"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.third_floor_area" label="Third Floor"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.basement_area" label="Basement"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.frontage_area" label="Frontage"></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-menu>
                        </v-col>
                    </v-row>
                  </template>

                  <v-divider class="my-8"></v-divider>

                  <template id="section-lease">
                    <h5 class="text-h7 mb-1 pa-0">Lease Info</h5>
                    <v-row>
                        <v-col cols="6">
                            <!-- <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.lease_start_date"
                                v-validate="''"
                                :error-messages="errors.collect('form.lease_start_date')"
                                placeholder="dd/mm/yyyy"
                                label="Lease Start Date"
                                data-vv-name="form.lease_start_date"
                                data-vv-as="Lease Start Date"
                                mask="##/##/####"
                                v-mask="'##/##/####'"
                                append-icon="mdi-calendar"
                            ></v-text-field> -->
                            <date-input
                              v-model="form.lease_start_date"
                              label="Lease Start Date"
                            ></date-input>
                        </v-col>
                        <v-col cols="6">
                            <!-- <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.lease_end_date"
                                v-validate="''"
                                :error-messages="errors.collect('form.lease_end_date')"
                                placeholder="dd/mm/yyyy"
                                label="Lease End Date"
                                data-vv-name="form.lease_end_date"
                                data-vv-as="Lease End Date"
                                mask="##/##/####"
                                v-mask="'##/##/####'"
                                append-icon="mdi-calendar"
                            ></v-text-field> -->
                            <date-input
                              v-model="form.lease_end_date"
                              label="Lease End Date"
                            ></date-input>
                        </v-col>
                        <v-col cols="6">
                            <!-- <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.next_review_date"
                                v-validate="''"
                                :error-messages="errors.collect('form.next_review_date')"
                                placeholder="dd/mm/yyyy"
                                label="Next Review Date"
                                data-vv-name="form.next_review_date"
                                data-vv-as="Next Review Date"
                                mask="##/##/####"
                                v-mask="'##/##/####'"
                                append-icon="mdi-calendar"
                            ></v-text-field> -->
                            <date-input
                              v-model="form.next_review_date"
                              label="Next Review Date"
                            ></date-input>
                        </v-col>
                        <v-col cols="6">
                            <!-- <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.break_date"
                                v-validate="''"
                                :error-messages="errors.collect('form.break_date')"
                                placeholder="dd/mm/yyyy"
                                label="Break Date"
                                data-vv-name="form.break_date"
                                data-vv-as="Break Date"
                                mask="##/##/####"
                                v-mask="'##/##/####'"
                                append-icon="mdi-calendar"
                            ></v-text-field> -->
                            <date-input
                              v-model="form.break_date"
                              label="Break Date"
                            ></date-input>
                        </v-col>
                        <v-col cols="6">
                          <v-textarea
                          
                            v-model="form.rent_review_clause"
                            label="Rent Review Clause"
                            data-vv-name="form.rent_review_clause"
                            data-vv-as="Rent Review Clause"
                            outlined
                          ></v-textarea>
                        </v-col>
                        <v-col cols="6">
                          <v-textarea
                            v-model="form.break_clause"
                            label="Break Clause"  
                            data-vv-name="form.break_clause"
                            data-vv-as="Break Clause"
                            outlined
                          ></v-textarea>
                        </v-col>
                    </v-row>
                  </template>

                  <v-divider class="my-8"></v-divider>

                  <template id="section-rent-info">
                    <h5 class="text-h7 mb-1 pa-0">Rent Info</h5>
                    <v-row>
                        <v-col cols="12">
                            <currency-select v-model="form.currency" ref="currencySelectRef" label="Currency"></currency-select>
                        </v-col>
                        <v-col cols="6">
                            <currency-input
                              v-model="form.rent_pa"
                              :validation="'decimal:2'"
                              label="Rent Pa"
                              :errorMsgs="errors.collect('form.rent_pa')"
                              :currency="form.currency ? form.currency.symbol : ''"
                            ></currency-input>
                        </v-col>
                        <v-col cols="6">
                            <!-- <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.rent_sqft"
                                v-validate="''"
                                :error-messages="errors.collect('form.rent_sqft')"
                                label="Rent per sqft"
                                data-vv-name="form.rent_sqft"
                                data-vv-as="Rent per sqft"
                                type="number"
                            ></v-text-field> -->
                            <currency-input
                              v-model="form.rent_sqft"
                              :validation="'decimal:2'"
                              label="Rent per sqft"
                              :errorMsgs="errors.collect('form.rent_sqft')"
                              :currency="form.currency ? form.currency.symbol : ''"
                            ></currency-input>
                        </v-col>
                        <v-col cols="6">
                            <!-- <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.rateable_value"
                                v-validate="''"
                                :error-messages="errors.collect('form.rateable_value')"
                                label="Rateable Value"
                                data-vv-name="form.rateable_value"
                                data-vv-as="Rateable Value"
                                type="number"
                            ></v-text-field> -->
                            <currency-input
                              v-model="form.rateable_value"
                              :validation="'decimal:2'"
                              label="Rateable Value"
                              :errorMsgs="errors.collect('form.rateable_value')"
                              :currency="form.currency ? form.currency.symbol : ''"
                            ></currency-input>
                        </v-col>
                        <v-col cols="6">
                            <!-- <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.service_charge"
                                v-validate="''"
                                :error-messages="errors.collect('form.service_charge')"
                                label="Service Charge"
                                data-vv-name="form.service_charge"
                                data-vv-as="Service Charge"
                                type="number"
                            ></v-text-field> -->
                            <currency-input
                              v-model="form.service_charge"
                              :validation="'decimal:2'"
                              label="Service Charge"
                              :errorMsgs="errors.collect('form.service_charge')"
                              :currency="form.currency ? form.currency.symbol : ''"
                            ></currency-input>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.incentive"
                                v-validate="''"
                                :error-messages="errors.collect('form.incentive')"
                                label="Incentive"
                                data-vv-name="form.incentive"
                                data-vv-as="Incentive"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.planning"
                                v-validate="''"
                                :error-messages="errors.collect('form.planning')"
                                label="Planning"
                                data-vv-name="form.planning"
                                data-vv-as="Planning"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                  </template>

                  <v-divider class="my-8"></v-divider>

                  <template id="section-contacts">
                    <div style="display: flex; z-index: 20;">
                      <h5 class="text-h7 mb-1 pa-0">Landlord Contacts</h5>
                      <v-spacer></v-spacer>
                      <h5 class="text-h7 mb-1 pa-0">Filled from Scheme</h5>
                    </div>
                    <v-row>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                small-chips
                                multiple
                                hide-details
                                v-model="form.landlords"
                                :loading="landlords.loading"
                                :items="landlords.items"
                                :search-input.sync="landlords.search"
                                cache-items
                                flat
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Landlords"
                                v-validate="''"
                                :error-messages="errors.collect('form.landlords')"
                                data-vv-name="form.landlords"
                                data-vv-as="Landlord"
                                disabled
                            >
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                small-chips
                                disabled
                                multiple
                                hide-details
                                v-model="form.landlord_contacts"
                                :loading="landlordContacts.loading"
                                :items="landlordContacts.items"
                                :search-input.sync="landlordContacts.search"
                                cache-items
                                flat
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Landlord Contacts"
                                v-validate="''"
                                :error-messages="errors.collect('form.landlord_contacts')"
                                data-vv-name="form.landlord_contacts"
                                data-vv-as="Landlord Contact"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                small-chips
                                disabled
                                multiple
                                hide-details
                                v-model="form.landlord_agents"
                                :loading="landlordAgents.loading"
                                :items="landlordAgents.items"
                                :search-input.sync="landlordAgents.search"
                                cache-items
                                flat
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Landlord Agents"
                                v-validate="''"
                                :error-messages="errors.collect('form.landlord_agents')"
                                data-vv-name="form.landlord_agents"
                                data-vv-as="Landlord Agent"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                small-chips
                                disabled
                                multiple
                                hide-details
                                v-model="form.landlord_agent_contacts"
                                :loading="landlordAgentContacts.loading"
                                :items="landlordAgentContacts.items"
                                :search-input.sync="landlordAgentContacts.search"
                                cache-items
                                flat
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Landlord Agent Contacts"
                                v-validate="''"
                                :error-messages="errors.collect('form.landlord_agent_contacts')"
                                data-vv-name="form.landlord_agent_contacts"
                                data-vv-as="Landlord Agent Contact"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                  </template>

                  <!-- <v-divider class="my-8"></v-divider> -->

                  <!-- <template id="section-tenant-contacts">
                    <h5 class="text-h7 mb-1 pa-0">Tenant Contacts</h5>
                    
                  </template> -->
                </form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed @click="closeDialog">Cancel</v-btn>
                <v-btn depressed :loading="loading"  color="primary" @click="submit">Save</v-btn>
            </v-card-actions>
            <create-company-dialog @created="fillCompany" ref="createCompanyDialog"></create-company-dialog>
            <create-user-dialog @created="fillUser" ref="createUserDialog"></create-user-dialog>
        </v-card>
    </v-dialog>
</template>
<script>
import {mask} from 'vue-the-mask'
import countries from '@/data/countries'
import CurrencySelect from "@/components/common/currencySelect.vue";
import currencyInput from "@/components/common/currencyInput.vue";
import AddressFinder from "@/components/common/addressFinder.vue";

import dateInput from '@/components/common/dateInput.vue'

export default {
  components: {
    CurrencySelect,
    currencyInput,
    AddressFinder,
    dateInput,
    CreateCompanyDialog: () => import('@/components/companies/createCompanyDialog'),
    CreateUserDialog: () => import('@/components/users/createUserDialog'),
  },
  directives: {
    mask,
  },
  data: () => ({
    prefill: false,
    dialog: false,
    countries: countries,
    step: 1,
    schemeTypes: [
      'Leisure',
      'Out of town',
      'Shopping centres',
    ],

    creation_ids: {
      user: null,
      company: null,
    },

    landlordContacts: {
      loading: false,
      items: [],
      search: null,
    },
    landlordAgentContacts: {
      loading: false,
      items: [],
      search: null,
    },
    landlords: {
      loading: false,
      items: [],
      search: null,
    },
    landlordAgents: {
      loading: false,
      items: [],
      search: null,
    },
    tenants: {
      loading: false,
      items: [],
      search: null,
    },
    legalTenants: {
      loading: false,
      items: [],
      search: null,
    },
    tenantAgents: {
      loading: false,
      items: [],
      search: null,
    },
    tenantAgentContacts: {
      loading: false,
      items: [],
      search: null,
    },
    tenantContacts: {
      loading: false,
      items: [],
      search: null,
    },
    scheme: {
      loading: false,
      items: [],
      search: null,
    },

    loading: false,


    form: {
      scheme: null,
      

      building_num: '',
      company_id: null,
      legal_tenant_id: null,
      nia_sqrt: '',
      area_size_type: 'sqft',
      itza_area: '',
      ground_floor_area: '',
      first_floor_area: '',
      second_floor_area: '',
      third_floor_area: '',
      basement_area: '',
      frontage_area: '',

      lease_start_date: '',
      lease_end_date: '',
      next_review_date: '',
      break_date: '',
      rent_review_clause: '',
      break_clause: '',
      rent_pa: '',
      rent_sqft: '',
      incentive: '',
      currency: null,

      mezzanine: '',
      garden_centre: '',
      rateable_value: '',
      service_charge: '',
      planning: '',

      landlords: [],
      landlord_contacts: [],
      landlord_agents: [],
      landlord_agent_contacts: [],
      tenant_agents: [],
      tenant_agent_contacts: [],
      tenant_contacts: [],
      address: {
        street: '',
        street2: '',
        city: '',
        region: '',
        post_code: '',
        country: 'United Kingdom',
        notes: '',
      },
    },
    initialForm: {},

    areaChecklist: {
      nia_sqrt: false,
      mezzanine: false,
      garden_centre: false,
      itza_area: false,
      ground_floor_area: false,
      first_floor_area: false,
      second_floor_area: false,
      third_floor_area: false,
      basement_area: false,
      frontage_area: false,
    },

  }),
  watch: {
    'form.scheme'(value) {
      if (value) {
        this.fillLandlords(value)
        this.fillAddress(value)
      }else{
        this.clearLandlords()
        this.clearAddress()
      }
    },

    'scheme.search'(search) {
      this.getScheme(search);
    },
    'landlords.search'(search) {
      this.getCompanies(search);
    },
    'landlordContacts.search'(search) {
      this.getUsers(search);
    },
    'landlordAgents.search'(search) {
      this.getCompanies(search);
    },
    'landlordAgentContacts.search'(search) {
      this.getUsers(search);
    },
    'tenants.search'(search) {
      this.getTenants(search);
    },
    'legalTenants.search'(search) {
      this.getLegalTenants(search);
    },
    'tenantAgents.search'(search) {
      this.getTenantAgents(search);
    },
    'tenantAgentContacts.search'(search) {
      this.getTenantAgentContacts(search);
    },
    'tenantContacts.search'(search) {
      this.getTenantContacts(search);
    },
  },
  computed: {
    formValidated() {
      return Object.keys(this.fields).some(key => this.fields[key].validated) &&
        Object.keys(this.fields).some(key => this.fields[key].valid)
    },
    formHasChanges() {
      return JSON.stringify(this.form) !== JSON.stringify(this.initialForm)
    }
  },
  methods: {
    verifyRetailer(retailer){
      let object ={
        icon: 'grey',
        tooltip: 'This retailer has never been verified',
      }
      if((retailer.scraper.data && retailer.scraper.data.verified_at) || retailer.scraper.verified_at){
        if(retailer.is_verified){
          object.icon = 'green'
          object.tooltip = 'This retailer is verified'
        }else{
          object.icon = 'orange lighten-1'
          object.tooltip = 'This retailer is not currently verified'
        }
      }
      return object
    },

    closeDialog() {
      this.$emit('close')
      this.dialog = false
    },
    openDialog(scheme) {
      if (scheme) {
        this.prefill = true
        this.prefillScheme(scheme)
      }else{
        this.dialog = true
        this.$nextTick(() => {
          this.form.currency = this.$refs.currencySelectRef.selectByCode(this.$auth.user().currency ? this.$auth.user().currency : 'GBP')
        })
      }
      
    },

    fillLandlords(data){
      this.form.landlords = data.landlords.data
      this.landlords.items = data.landlords.data

      this.form.landlord_contacts = data.landlord_contacts.data
      this.landlordContacts.items = data.landlord_contacts.data

      this.form.landlord_agents = data.landlord_agents.data
      this.landlordAgents.items = data.landlord_agents.data

      this.form.landlord_agent_contacts = data.landlord_agent_contacts.data
      this.landlordAgentContacts.items = data.landlord_agent_contacts.data
    },
    fillAddress(data){
      
      // address is an object that sometimes has address.data, and sometimes address itself has the data, so we need to check for both
      if(data.address.data){
        this.form.address = data.address.data
      }else{
        this.form.address = data.address
      }
    },

    createUser(id){
      this.creation_ids.user = id
      this.$refs.createUserDialog.showDialog()
    },

    createCompany(id){
      this.creation_ids.company = id
      this.$refs.createCompanyDialog.showDialog()
    },

    fillUser(user){
      // use the creation id to fill the correct field using case statement, id 0 is tenant agent contact, 1 is tenant contact etc etc
      switch(this.creation_ids.user){
        case 'tenant_agent_contact':
          this.tenantAgentContacts.items.push(user)
          this.form.tenant_agent_contacts.push(user)
          break;
        case 'tenant_contact':
          this.tenantContacts.items.push(user)
          this.form.tenant_contacts.push(user)
          break;
        case 'landlord_contact':
          this.landlordAgentContacts.items.push(user)
          this.form.landlord_agent_contacts.push(user)
          break;
        case 'landlord_agent_contact':
          this.landlordContacts.items.push(user)
          this.form.landlord_contacts.push(user)
          break;
        default:
          break;
      }
    },

    fillCompany(company){
      // same as fill user, except for companies, 0 is tenant, 1 is legal tenant, 2 is tenant agent, 3 is landlords, 4 is landlord agent
      switch(this.creation_ids.company){
        case 'tenant':
          this.tenants.items.push(company)
          this.form.company_id = company
          break;
        case 'legal_tenant':
          this.legalTenants.items.push(company)
          this.form.legal_tenant_id = company
          break;
        case 'tenant_agent':
          this.tenantAgents.items.push(company)
          this.form.tenant_agents.push(company)
          break;
        case 'landlord':
          this.landlords.items.push(company)
          this.form.landlords.push(company)
          break;
        case 'landlord_agent':
          this.landlordAgents.items.push(company)
          this.form.landlord_agents.push(company)
          break;
        default:
          break;
      }
    },

    clearLandlords(){
      this.form.landlords = []
      this.form.landlord_contacts = []
      this.form.landlord_agents = []
      this.form.landlord_agent_contacts = []
    },

    clearAddress(){
      this.form.address = {
        street: '',
        street2: '',
        city: '',
        region: '',
        post_code: '',
        country: 'United Kingdom',
        notes: '',
      }
    },

    clearForm() {
      this.form = Object.assign({}, this.initialForm)
    },

    async getScheme(search) {
      this.scheme.loading = true
      this.$http.get("/schemes?include=address,landlords,landlord_contacts,landlord_agents,landlord_agent_contacts",{
        params: {
          q: search,
          per_page: 50,
        }
      }).then(response => {
        if(search != ''){
          this.scheme.items = response.data.data.map(scheme => {
              scheme.label = `${scheme.name} - ${scheme.address.data.full_address}`
              return scheme
          })
         
        }else{
          this.scheme.items = []
        }
        
        this.scheme.loading = false
      }).catch(error => {
        this.scheme.loading = false
      })
    },

    async prefillScheme(scheme) {
      this.$http.get(`/schemes/${scheme}`, {
        params: {
          include: 'address,landlords,landlord_contacts,landlord_agents,landlord_agent_contacts'
        }
      }).then(response => {
        let label = `${response.data.name} - ${response.data.address.full_address}`
        response.data.label = label

        this.scheme.items.push(response.data)
        this.form.scheme = response.data
        this.dialog = true

        this.$nextTick(() => {
          this.form.currency = this.$refs.currencySelectRef.selectByCode(this.$auth.user().currency ? this.$auth.user().currency : 'GBP')
        })
      })
    },

    async getTenants(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          include: 'scraper',
          q: search,
          per_page: 100,
        }
      });
      this.tenants.items = response.data.data;
    },
    async getLegalTenants(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          include: 'scraper',
          q: search,
          per_page: 100,
        }
      });
      this.legalTenants.items = response.data.data;
    },
    async getTenantAgents(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.tenantAgents.items = response.data.data;
    },
    async getTenantAgentContacts(search) {
      const response = await this.$http.get('/users/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.tenantAgentContacts.items = response.data.data;
    },
    async getTenantContacts(search) {
      const response = await this.$http.get('/users/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.tenantContacts.items = response.data.data;
    },
    async getCompanies(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.landlords.items = response.data.data;
      this.landlordAgents.items = response.data.data;
    },
    async getUsers(search) {
      const response = await this.$http.get('/users/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.landlordContacts.items = response.data.data;
      this.landlordAgentContacts.items = response.data.data;
    },
    prepareFormData() {
      let form = Object.assign({}, this.form)
      form.lease_start_date = this.formatDate(this.form.lease_start_date)
      form.lease_end_date = this.formatDate(this.form.lease_end_date)
      form.next_review_date = this.formatDate(this.form.next_review_date)
      form.break_date = this.formatDate(this.form.break_date)

      form.currency = form.currency.code

      let coordinates = {
        lat: null,
        lng: null
      }

      // using form.address.lat/lng, shift the coordinates to the coordinates object offset by 0.001 in a random circular direction
      if (form.address.lat && form.address.lng) {
        const offset = 0.0002; // offset in degrees
        const angle = Math.random() * 2 * Math.PI; // random angle in radians
        coordinates.lat = parseFloat(form.address.lat) + offset * Math.cos(angle);
        coordinates.lng = parseFloat(form.address.lng) + offset * Math.sin(angle);
      }

      form.address.position = coordinates;

      // take only the id's of the scheme, landlords, landlord_contacts, landlord_agents, landlord_agent_contacts
      // form.scheme = form.scheme.id
      form.landlords = form.landlords.map(landlord => landlord.id)
      form.landlord_contacts = form.landlord_contacts.map(contact => contact.id)
      form.landlord_agents = form.landlord_agents.map(agent => agent.id)
      form.landlord_agent_contacts = form.landlord_agent_contacts.map(contact => contact.id)
      return form;
    },
    formatDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async submit() {
      if (await this.$formValidator.validate(this.form)) {
        try {
          await this.$http.post(`schemes/${this.form.scheme.id}/properties`, this.prepareFormData())
          this.clearForm()
          this.$emit('added')
          this.dialog = false
          
        } catch (e) {
          this.$validationException(e)
        }
      }
    }
  },
  mounted() {
    this.initialForm = Object.assign({}, this.form)
  }
}
</script>